/**
 * Create Guarantor Page
 */
import React from 'react';

const CreateGuarantor = () => {
  return (
    <div>
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Add Guarantor</h1>
      <p className="text-gray-600 dark:text-gray-400 mt-2">Add a new guarantor for a loan</p>
    </div>
  );
};

export default CreateGuarantor;
